export default {
  highlightPreTag: "<ais-highlight-0000000000>",
  highlightPostTag: "</ais-highlight-0000000000>"
};


// WEBPACK FOOTER //
// ../node_modules/react-instantsearch/es/src/core/highlightTags.js